import { render } from "./RefundProducts.vue?vue&type=template&id=a0a6c8d8"
import script from "./RefundProducts.vue?vue&type=script&lang=js"
export * from "./RefundProducts.vue?vue&type=script&lang=js"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__